import { MT_WEBVIEW } from '~/config/app.constants';

const DEFAULT_OLD_BRAND_COLOR = '#232A3E';

const MT_LAYOUT_HIDDEN = 'mtLayoutHidden';

const persistLayoutHidden = (value: string | null): boolean => {
  try {
    if (value) {
      sessionStorage.setItem(MT_LAYOUT_HIDDEN, value);
    }
    return sessionStorage.getItem(MT_LAYOUT_HIDDEN) === 'true';
  } catch {
    return value === 'true';
  }
};

export const isLayoutHidden = () => {
  const params = new URLSearchParams(window.location.search);
  const layoutParam = params.get(MT_LAYOUT_HIDDEN);
  const isEmbeddedRoleplay = params.get('isEmbeddedRoleplay');

  return (
    window.navigator.userAgent.includes(MT_WEBVIEW) ||
    isEmbeddedRoleplay === 'true' ||
    persistLayoutHidden(layoutParam)
  );
};

/**
 * This function is used to set the default brand color for the learner layout.
 * TODO: This needs to be fixed, when we have done GA, then through script we will set the default brand color.
 */
export const setDefaultBrandColor = (color: string) => {
  const isOldBrandColor = color === DEFAULT_OLD_BRAND_COLOR;
  if (isOldBrandColor) {
    return '';
  }
  return color;
};
